export const cocktailConstants = {
  CONTRIBUTE_REQUEST: 'COCKTAIL_CONTRIBUTE_REQUEST',
  CONTRIBUTE_SUCCESS: 'COCKTAIL_CONTRIBUTE_SUCCESS',
  CONTRIBUTE_FAILURE: 'COCKTAIL_CONTRIBUTE_FAILURE',

  UPDATE_INGREDIENT_REQUEST: 'COCKTAIL_UPDATE_REQUEST',
  UPDATE_INGREDIENT_SUCCESS: 'COCKTAIL_UPDATE_SUCCESS',
  UPDATE_INGREDIENT_FAILURE: 'COCKTAIL_UPDATE_FAILURE',

  GETALLINGREDIENTS_REQUEST: 'COCKTAIL_GETALLINGREDIENTS_REQUEST',
  GETALLINGREDIENTS_SUCCESS: 'COCKTAIL_GETALLINGREDIENTS_SUCCESS',
  GETALLINGREDIENTS_FAILURE: 'COCKTAIL_GETALLINGREDIENTS_FAILURE',

  GETALLRECIPES_REQUEST: 'COCKTAIL_GETALLRECIPES_REQUEST',
  GETALLRECIPES_SUCCESS: 'COCKTAIL_GETALLRECIPES_SUCCESS',
  GETALLRECIPES_FAILURE: 'COCKTAIL_GETALLRECIPES_FAILURE',

  GETMYRECIPES_REQUEST: 'COCKTAIL_GETMYRECIPES_REQUEST',
  GETMYRECIPES_SUCCESS: 'COCKTAIL_GETMYRECIPES_SUCCESS',
  GETMYRECIPES_FAILURE: 'COCKTAIL_GETMYRECIPES_FAILURE',

  GETINGREDIENTBYID_REQUEST: 'COCKTAIL_GETINGREDIENTBYID_REQUEST',
  GETINGREDIENTBYID_SUCCESS: 'COCKTAIL_GETINGREDIENTBYID_SUCCESS',
  GETINGREDIENTBYID_FAILURE: 'COCKTAIL_GETINGREDIENTBYID_FAILURE',

  GETRECIPEIMAGEBYID_REQUEST: 'COCKTAIL_GETRECIPEIMAGEBYID_REQUEST',
  GETRECIPEIMAGEBYID_SUCCESS: 'COCKTAIL_GETRECIPEIMAGEBYID_SUCCESS',
  GETRECIPEIMAGEBYID_FAILURE: 'COCKTAIL_GETRECIPEIMAGEBYID_FAILURE',

  DELETEINGREDIENT_REQUEST: 'COCKTAIL_DELETEINGREDIENT_REQUEST',
  DELETEINGREDIENT_SUCCESS: 'COCKTAIL_DELETEINGREDIENT_SUCCESS',
  DELETEINGREDIENT_FAILURE: 'COCKTAIL_DELETEINGREDIENT_FAILURE',

  DELETERECIPE_REQUEST: 'COCKTAIL_DELETERECIPE_REQUEST',
  DELETERECIPE_SUCCESS: 'COCKTAIL_DELETERECIPE_SUCCESS',
  DELETERECIPE_FAILURE: 'COCKTAIL_DELETERECIPE_FAILURE',

  UPDATECOCKTAILCT_REQUEST: 'COCKTAIL_UPDATECOCKTAILCT_REQUEST',
  UPDATECOCKTAILCT_SUCCESS: 'COCKTAIL_UPDATECOCKTAILCT_SUCCESS',
  UPDATECOCKTAILCT_FAILURE: 'COCKTAIL_UPDATECOCKTAILCT_FAILURE',

  UPDATEFAVORITESCT_REQUEST: 'COCKTAIL_UPDATEFAVORITESCT_REQUEST',
  UPDATEFAVORITESCT_SUCCESS: 'COCKTAIL_UPDATEFAVORITESCT_SUCCESS',
  UPDATEFAVORITESCT_FAILURE: 'COCKTAIL_UPDATEFAVORITESCT_FAILURE',

  ADDREMOVEFAVORITES_REQUEST: 'COCKTAIL_ADDREMOVEFAVORITES_REQUEST',
  ADDREMOVEFAVORITES_SUCCESS: 'COCKTAIL_ADDREMOVEFAVORITES_SUCCESS',
  ADDREMOVEFAVORITES_FAILURE: 'COCKTAIL_ADDREMOVEFAVORITES_FAILURE'
};


// WEBPACK FOOTER //
// ./src/_constants/cocktail.constants.js